(function () {
  function openPopup(popup) {
    popup.classList.add('is-open');
    popup.setAttribute('aria-hidden', 'false');
    document.body.classList.add('oc-mc-popup--locked');
  }

  function closePopup(popup) {
    popup.classList.remove('is-open');
    popup.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('oc-mc-popup--locked');
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-oc-mc-popup]');
    if (trigger) {
      e.preventDefault();
      var popup = document.getElementById(trigger.dataset.ocMcPopup);
      if (popup) openPopup(popup);
      return;
    }

    var closeBtn = e.target.closest('[data-oc-mc-popup-close]');
    if (closeBtn) {
      var popup = closeBtn.closest('.oc-mc-popup');
      if (popup) closePopup(popup);
      return;
    }

    var inner = e.target.closest('[data-oc-mc-popup-inner]');
    if (inner && e.target === inner) {
      var popup = inner.closest('.oc-mc-popup');
      if (popup) closePopup(popup);
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      var popup = document.querySelector('.oc-mc-popup.is-open');
      if (popup) closePopup(popup);
    }
  });
})();
